import { DeliveryRequestItem } from '../../../../@types/model/deliveryRequest';
import { DeliverFilter } from '../../../../@types/model/deliver';
import { RefactoredDevice } from '../../../../@types/model/device';
import dayjs from 'dayjs';
import addSlot from './addSlot';
import { ProductSchedule } from '../../../../@types/model/productSchedule';
import { DeliveryConfiguration } from '../../../../@types/model/deliveryConfiguration';
import calcTotalSlotsOccupiedTruck from './calcTotalSlotsOccupiedTruck';

/**
 * Función para detectar se debemos desactivar o no el botón de añadir slot en cada dispositivo.
 */
const getDisabledAdd = (
  tableFilter: DeliverFilter,
  deliveryRequestItems: DeliveryRequestItem[],
  productSchedules: ProductSchedule[],
  rd: RefactoredDevice,
  deliveryConfiguration: DeliveryConfiguration | null
) => {
  if (rd.delivery_request_pending?.length) return true;
  if (!tableFilter.deliveryConfiguration) return true;
  if (!tableFilter.deviceGroup) return true;
  if (!rd.productSchedule) return true;

  const diff = tableFilter.receivedDate?.diff(dayjs(), 'day') ?? 2;

  let extra_percentage = diff * 5;
  // let percent_initial = rd.percent;
  let totalFilledKg = 0;
  deliveryRequestItems
    .filter((sri: DeliveryRequestItem) => {
      if (rd.attributes.is_ref_of && rd.attributes.is_ref_of.split(':').length === 3)
        return sri.device === rd.attributes.is_ref_of.split(':')[2];
      else return sri.device === rd.guid;
    })
    .forEach((sri: DeliveryRequestItem) => (totalFilledKg += sri.quantity));

  // let percent_slots = 0;

  // percent_initial = percent_initial / (1 + extra_percentage / 100);
  // percent_slots = percent_slots / (1 + extra_percentage / 100);

  // percent_slots = ((totalFilledKg / rd.capacidad) * 100) / (1 + extra_percentage / 100);

  // Debemos calcular la cantidad que deberíamos meter en el caso de que quisieramos meter más. Por tanto hay que buscar cual es el siguiente producto de la crianza a introducir, y mirar de ver los kg que se deben meter.
  let newDeliveryRequestItem: DeliveryRequestItem | null = addSlot(
    rd,
    deliveryRequestItems,
    productSchedules,
    deliveryConfiguration
  );

  if (newDeliveryRequestItem) {
    //Obtenemos que podemos añadir en el silo. Vamos a ver si el truck cabría...

    let totalTruck = 0;
    deliveryRequestItems.forEach((dri: DeliveryRequestItem) => {
      totalTruck += dri.quantity;
    });
    if (deliveryConfiguration) {
      if (
        deliveryConfiguration.configuration.max * deliveryConfiguration.configuration.slot_amount <
        totalTruck + newDeliveryRequestItem.quantity
      ) {
        // return true; // Desactivamos esta restricción, ya que queremos poder hacer pedidos de cantidades infinitas
      }
    }
    if (deliveryConfiguration) {
      if (
        !(
          calcTotalSlotsOccupiedTruck(
            deliveryRequestItems,
            deliveryConfiguration,
            newDeliveryRequestItem
          ) <= deliveryConfiguration.configuration.max
        )
      ) {
        // return true; // Desactivamos esta restricción, ya que queremos poder hacer pedidos de cantidades infinitas
      }
    }

    const percentCondition: boolean =
      rd.percent + ((totalFilledKg + newDeliveryRequestItem.quantity) / rd.capacidad) * 100 >
      100 * ((100 + extra_percentage) / 100);
    return percentCondition;
  } else {
    return true;
  }
};

export default getDisabledAdd;
